import fetchLimit from './fetchLimit'

export { fetchLimit }

export interface ILimit {
  add: number
  edit: number
  copy: number
  transfer: number
  resetDate: Date
}

export enum UpdateLimitType {
  Add = 'free_limitations_add_count',
  Edit = 'free_limitations_edit_count',
  Transfer = 'free_limitations_move_count',
  Copy = 'free_limitations_copy_count',
}
